import React, { FC } from "react";
import { Block } from "kanopi-components/Block";
import { SidePadder } from "kanopi-components/Layout/SidePadder";
import { HeadingMedium, ParagraphMedium } from "kanopi-components/typography";
import { Image } from "kanopi-components/Image";
import { ContactUsModal } from "kw/components/ContactUs/ContactUs";

export const ClaimsErrorPage: FC = () => {
  return (
    <SidePadder>
      <Block
        data-testid="referred"
        width="100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Image
          src="knockout.svg"
          maxWidth="400px"
          strictRatio
          style={{
            marginTop: "32px",
          }}
        />
        <HeadingMedium center marginTop="scale500">
          Sorry, we&apos;re unable to process claims online for this policy.
        </HeadingMedium>
        <ParagraphMedium center>
          Please <ContactUsModal buttonText="contact us" /> for assistance.
        </ParagraphMedium>
      </Block>
    </SidePadder>
  );
};
